import { render, staticRenderFns } from "./HijackScreenshareModal.vue?vue&type=template&id=07d558fa&scoped=true"
import script from "./HijackScreenshareModal.vue?vue&type=script&lang=js"
export * from "./HijackScreenshareModal.vue?vue&type=script&lang=js"
import style0 from "./HijackScreenshareModal.vue?vue&type=style&index=0&id=07d558fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d558fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d558fa')) {
      api.createRecord('07d558fa', component.options)
    } else {
      api.reload('07d558fa', component.options)
    }
    module.hot.accept("./HijackScreenshareModal.vue?vue&type=template&id=07d558fa&scoped=true", function () {
      api.rerender('07d558fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/HijackScreenshareModal.vue"
export default component.exports